export default __webpack_public_path__ + "static/media/footer.e5766af9.png";